export enum FileAttachmentType {
  SingleFile = 1,
  MultipleFiles = 2,
}